const PRONOSTIC_API_PATH = "/pronostic";

export const PREDICTIONS_API_ENDPOINTS = {
  ACTIVE_COMPETITION: `${PRONOSTIC_API_PATH}/competitions/active`,
  COMPETITION_DETAIL: `${PRONOSTIC_API_PATH}/competitions/:competitionId`,
  GAMES: `${PRONOSTIC_API_PATH}/games`,
  GAME_DETAIL: `${PRONOSTIC_API_PATH}/games/:gameId`,
  GAME_PREDICTION: `${PRONOSTIC_API_PATH}/games/:gameId/prediction`,
  MY_PREDICTIONS: `${PRONOSTIC_API_PATH}/me/predictions`,
  RANKING_GLOBAL: `${PRONOSTIC_API_PATH}/competitions/:competitionId/ranking`,
  COMPETITION_STANDINGS: `${PRONOSTIC_API_PATH}/competitions/:competitionId/standings`,
  PARTICIPANT_PREDICTIONS: `${PRONOSTIC_API_PATH}/competitions/:competitionId/participants/:userId/predictions`,
  COMPETITION_PRIZES: `${PRONOSTIC_API_PATH}/competitions/:competitionId/prizes`,
  MY_BADGES: `${PRONOSTIC_API_PATH}/me/badges`,
  MY_STATS: `${PRONOSTIC_API_PATH}/me/stats`,
  ME_PREFERENCES: `${PRONOSTIC_API_PATH}/me/preferences`,
  ME_LEAVE: `${PRONOSTIC_API_PATH}/me/leave`,
  ME_JOIN: `${PRONOSTIC_API_PATH}/me/join`,
};

export const getGameDetailEndpoint = (gameId: string) =>
  PREDICTIONS_API_ENDPOINTS.GAME_DETAIL.replace(":gameId", gameId);

export const getGamePredictionEndpoint = (gameId: string) =>
  PREDICTIONS_API_ENDPOINTS.GAME_PREDICTION.replace(":gameId", gameId);

export const getCompetitionDetailEndpoint = (competitionId: string) =>
  PREDICTIONS_API_ENDPOINTS.COMPETITION_DETAIL.replace(":competitionId", competitionId);

export const getRankingGlobalEndpoint = (competitionId: string) =>
  PREDICTIONS_API_ENDPOINTS.RANKING_GLOBAL.replace(":competitionId", competitionId);

export const getCompetitionStandingsEndpoint = (competitionId: string) =>
  PREDICTIONS_API_ENDPOINTS.COMPETITION_STANDINGS.replace(":competitionId", competitionId);

export const getParticipantPredictionsEndpoint = (competitionId: string, userId: string) =>
  PREDICTIONS_API_ENDPOINTS.PARTICIPANT_PREDICTIONS
    .replace(":competitionId", competitionId)
    .replace(":userId", userId);

export const getCompetitionPrizesEndpoint = (competitionId: string) =>
  PREDICTIONS_API_ENDPOINTS.COMPETITION_PRIZES.replace(":competitionId", competitionId);
